import { combine } from 'effector'
import { AuthTab, model as tabsModel } from '~/features/change-auth-type'
import { model as signUpModel } from '~/features/subscriber/sign-up'

export const $isSignUpByPhoneActivated = combine(
  signUpModel.$signUpWithPhoneEnabled,
  tabsModel.$selectedTab,
  (signInWithPhoneEnabled, selectedTab) =>
    signInWithPhoneEnabled && selectedTab === AuthTab.Phone
)

export const $isSignUpByEmailActivated = combine(
  signUpModel.$signUpWithPhoneEnabled,
  tabsModel.$selectedTab,
  (signInWithPhoneEnabled, selectedTab) =>
    !signInWithPhoneEnabled || selectedTab === AuthTab.Email
)
